import { Injectable } from '@angular/core';
import { GiftCard } from '../models/gift-card';
import { Observable, BehaviorSubject } from 'rxjs';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { queries } from './queries';

@Injectable({
  providedIn: 'root',
})
export class GiftCardService {
  private giftCardSubj: BehaviorSubject<GiftCard>;
  giftCardSubj$: Observable<GiftCard>;

  constructor(private apollo: Apollo) {
    this.giftCardSubj = new BehaviorSubject<GiftCard>(undefined);
    this.giftCardSubj$ = this.giftCardSubj.asObservable();
  }

  /**
   * This method fetches GiftCards Page data and, binds it to ViewModel and,
   * Sets that value on GiftCardSubject.
   */
  queryEarnRedeem() {
    this.apollo
      .query({
        query: gql`
          ${queries.allGiftCards}
        `,
      })
      .subscribe(
        (res: any) => {
          const temp = new GiftCard().deserialize(res.data.allGiftCards[0]);
          this.giftCardSubj.next(temp);
        },
        (err) => {
          this.giftCardSubj.next(undefined);
        }
      );
  }

  /**
   * This method is used to check GiftCardSubject's value.
   * Useful to avoid unnecessary HTTP calls.
   */
  hasValue() {
    return this.giftCardSubj.getValue() !== undefined ? true : false;
  }
}
